import React, { useState } from "react";

const MarketMobileTabs = ({
  activeTab,
  onTabChange,
  onFilterClick,
  searchQuery,
  setSearchQuery,
}) => {
  const [isSearchVisible, setIsSearchVisible] = useState(false);

  const handleSearchIconClick = () => {
    setIsSearchVisible(true);
  };

  const handleCloseSearch = () => {
    setIsSearchVisible(false);
  };

  if (isSearchVisible) {
    return (
      <div className="px-4 py-3 bg-white flex items-center gap-2 border-y border-[#0000001A]">
        <div className="relative flex-grow">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <svg
              width="10"
              height="10"
              viewBox="0 0 10 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.5 9.5L7.325 7.325M8.5 4.5C8.5 6.70914 6.70914 8.5 4.5 8.5C2.29086 8.5 0.5 6.70914 0.5 4.5C0.5 2.29086 2.29086 0.5 4.5 0.5C6.70914 0.5 8.5 2.29086 8.5 4.5Z"
                stroke="#1A212F"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <input
            type="text"
            placeholder="Search players..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full pl-8 pr-4 py-2 border border-[#E6E6E6] placeholder:text-sm placeholder:text-[#1E1E1E] rounded-lg focus:outline-none focus:ring-1 focus:ring-blue-500"
            autoFocus
          />
        </div>
        <button
          onClick={handleCloseSearch}
          className="p-2"
          aria-label="Close search"
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13 1L1 13M1 1L13 13"
              stroke="#1A212F"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
    );
  }
  return (
    <>
      <div className="px-4  bg-white flex justify-between items-center  border-y border-[#0000001A]">
        <div className="flex items-center gap-4">
          <div
            onClick={() => onTabChange("all")}
            className={`py-4  text-xs ${
              activeTab === "all"
                ? "border-b-2 border-[#2283FF] text-[#2283FF] font-medium"
                : "text-[#1E1E1ECC]"
            }`}
          >
            All
          </div>
          <div
            onClick={() => onTabChange("for-sale")}
            className={`py-4  text-xs ${
              activeTab === "for-sale"
                ? "border-b-2 border-[#2283FF] text-[#2283FF] font-medium"
                : "text-[#1E1E1ECC]"
            }`}
          >
            For Sale
          </div>

          <div
            onClick={() => onTabChange("for-loan")}
            className={`py-4  text-xs ${
              activeTab === "for-loan"
                ? "border-b-2 border-[#2283FF] text-[#2283FF] font-medium"
                : "text-[#1E1E1ECC]"
            }`}
          >
            For Loan
          </div>
        </div>
        <div className="flex items-center gap-2">
          <div
            className="p-3 bg-[#F7F7F7] rounded-lg"
            onClick={handleSearchIconClick}
          >
            <svg
              width="10"
              height="10"
              viewBox="0 0 10 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.5 9.5L7.325 7.325M8.5 4.5C8.5 6.70914 6.70914 8.5 4.5 8.5C2.29086 8.5 0.5 6.70914 0.5 4.5C0.5 2.29086 2.29086 0.5 4.5 0.5C6.70914 0.5 8.5 2.29086 8.5 4.5Z"
                stroke="#1A212F"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div className="p-3 bg-[#F7F7F7] rounded-lg" onClick={onFilterClick}>
            <svg
              width="12"
              height="10"
              viewBox="0 0 12 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11 0.5H1L5 5.23V8.5L7 9.5V5.23L11 0.5Z"
                stroke="#1A212F"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>
      </div>
    </>
  );
};

export default MarketMobileTabs;
